import { makeStyles } from '@material-ui/core';

export const useResidentSectionStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    // Extra space before Plan Structure (settings gap is 16px).
    marginBottom: '16px',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
    padding: 0,
    boxSizing: 'border-box',
  },
  helper: {
    color: theme.palette.colors.grey110,
    fontFamily: 'Inter, sans-serif',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '22px',
    letterSpacing: '0.28px',
  },
  selectedList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
  },
  // 2+ residents: two-column grid (Figma 967:22953)
  selectedListGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    columnGap: '12px',
    rowGap: '12px',
    width: '100%',
  },
  search: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
  },
  addButton: {
    alignSelf: 'flex-start',
    minHeight: '40px',
    padding: '8px 16px',
    borderRadius: '4px',
    border: `1px solid ${theme.palette.colors.ceruleanMain}`,
    color: theme.palette.colors.ceruleanMain,
    fontFamily: 'Inter, sans-serif',
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: 'normal',
    letterSpacing: '0.32px',
    textTransform: 'none',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'rgba(0, 150, 202, 0.04)',
      border: `1px solid ${theme.palette.colors.ceruleanMain}`,
    },
  },
  addButtonIcon: {
    marginRight: '4px',
    fontSize: '20px',
  },
}));
